<template>
  <div id="app">
    <!-- 新增头部 -->
    <header class="header">
      <span class="header-title">学生信息报备系统</span>
      <button @click="close()" class="logout-btn">退出当前登录</button>
    </header>
    <!-- 新增侧边栏 -->
    <aside class="sidebar">
      <ul>
        <button class="nav-btn">学生管理</button>
        <button @click="backUser()" class="nav-btn">用户管理</button>
      </ul>
    </aside>
    <!-- 主体内容区域 -->
    <main>
      <button @click="addNewRecord" class="action-btn">新增</button>
      <input type="file" @change="handleFileUpload" />
      <button @click="importUsers" class="action-btn">导入excel</button>
      <button @click="exportUsers" class="action-btn">导出excel</button>
      <table>
        <thead>
        <tr>
          <th>姓名</th>
          <th>高考报名号</th>
          <th>身份证</th>
          <th>毕业高中</th>
          <th>手机号</th>
          <th>分数</th>
          <th>记录人</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(record, index) in records" :key="index">
          <td>{{ record.name }}</td>
          <td>{{ record.candidateNumber }}</td>
          <td>{{ record.idNumber }}</td>
          <td>{{ record.school }}</td>
          <td>{{ record.phone }}</td>
          <td>{{ record.grade }}</td>
          <td>{{ record.userName }}</td>
          <td>
            <button @click="editRecord(index)" class="table-btn">修改</button>
            <button @click="deleteRecord(index)" class="table-btn">删除</button>
          </td>
        </tr>
        </tbody>
      </table>
    </main>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      username: JSON.parse(localStorage.getItem("username")),
      status: JSON.parse(localStorage.getItem("status")),
      records: [],
      file: null,
      msg: ''
    };
  },
  methods: {
    close() {
      localStorage.clear();
      this.$router.push({ name: 'Login' });
    },
    backUser() {
      this.$router.push({ name: 'UserShow' });
    },
    addNewRecord() {
      this.$router.push({ name: 'SubmitSave' });
      console.log('添加新记录');
    },
    editRecord(index) {
      console.log('编辑记录：', this.records[index].id);
      this.$router.push({
        name: 'SubmitUpdate',
        query: {
          id: this.records[index].id
        }
      });
    },
    deleteRecord(index) {
      axios.delete(`http://39.100.109.86:8093/student/${this.records[index].id}`,{
        params: {  
              username:this.username
        }
      })
          .then(response => {
            console.log(response.data);
            location.reload();
          })
          .catch(error => {
            console.error(error);
          });
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    importUsers() {
      const formData = new FormData();
      formData.append('file', this.file);

      axios.post('http://39.100.109.86:8093/student/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        params: {
          username: this.username
        }
      }).then(response => {
        console.log(response.data);
        this.msg = response.data.msg;
        if (this.msg !== '') {
          alert(this.msg);
        } else {
          location.reload();
          alert('Import successful!');
        }
      }).catch(error => {
        console.error('There was an error!', error);
      });
    },
    exportUsers() {
      axios.get('http://39.100.109.86:8093/student/export', {
        params: {
          username: this.username
        },
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'students.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.error('There was an error!', error);
      });
    }
  },
  mounted() {
    axios.get('http://39.100.109.86:8093/student/page', {
      params: {
        username: this.username
      }
    }).then(response => {
      this.records = response.data.data;
      console.log(response.data.data);
    }).catch(error => {
      console.error(error);
    });
  },
};
</script>

<style>
/* 简约风格的样式 */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

table {
  margin-top: 20px;
  border-collapse: collapse;
  width: 100%;
}

th, td {
  text-align: left;
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

tr:hover {
  background-color: #f5f5f5;
}

button {
  margin: 0 5px;
  padding: 10px 20px;
  border: none;
  background-color: #3378C2;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

button:hover {
  background-color: #009FCC;
}

/* 新增头部样式 */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  padding: 10px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #3378C2;
}

.header-title {
  color: white;
  font-size: 24px;
  font-weight: bold;
}

.logout-btn {
  background-color: #3378C2;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}

.logout-btn:hover {
  background-color: #009FCC;
}

/* 侧边栏样式 */
.sidebar {
  position: fixed;
  top: 60px;
  bottom: 0;
  left: 0;
  width: 150px;
  padding: 20px;
  background-color: #f5f5f5;
}

.sidebar ul {
  list-style-type: none;
  padding: 0;
}

.sidebar button {
  width: 100%;
  margin-top: 10px;
  background-color: #3378C2;
  color: white;
  text-align: left;
  font-size: 16px;
  border: none;
  padding: 10px;
  cursor: pointer;
  border-radius: 4px;
}

.sidebar button:hover {
  background-color: #009FCC;
}

/* 主体内容样式 */
main {
  margin-left: 200px;
  padding: 20px;
}

thead tr {
  background-color: #f8f9fa;
}

tbody tr:hover {
  background-color: #e9ecef;
}

/* 表格按钮样式 */
.table-btn {
  background-color: #3378C2;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 4px;
}

.table-btn:hover {
  background-color: #009FCC;
}

.action-btn {
  margin: 10px 5px;
  padding: 10px 20px;
  background-color: #3378C2;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}

.action-btn:hover {
  background-color: #009FCC;
}
</style>
